import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { RequestParams, ResponseCatalog } from 'Models'
import { RbidosLeadModel } from 'Pages/lead'
import { Callback } from 'Src/types/utilTypes'

interface InitialState {
	all: ResponseCatalog<RbidosLeadModel>
	requestParams: RequestParams
	selectedLeadIds: number[]
}

const initialState: InitialState = {
	all: new ResponseCatalog<RbidosLeadModel>(),
	requestParams: new RequestParams(),
	selectedLeadIds: [],
}

export namespace LeadsNS {
	export type GetAll = PayloadAction<{
		params: RequestParams
		clear?: boolean
		callback?: Callback
	}>
	export type SetAll = PayloadAction<ResponseCatalog<RbidosLeadModel>>
	export type SetRequestParams = PayloadAction<RequestParams>
	export type ClearAll = PayloadAction
	export type SetLeadsIds = PayloadAction<number[]>
	export type ClearLeadsIds = PayloadAction
	export type MassUpdateLeadsIds = PayloadAction
	export type SocketMassUpdateLeadsIds = PayloadAction
	export type MassUpdateLeadsFile = PayloadAction<File>
}

export const leadsSlice = createSlice({
	name: 'leads',
	initialState,
	reducers: {
		getAll: (state, action: LeadsNS.GetAll) => {},
		setAll: (state, action: LeadsNS.SetAll) => {
			state.all = action.payload
		},

		setRequestParams: (state, action: LeadsNS.SetRequestParams) => {
			state.requestParams = action.payload
		},
		clearAll: (state, action: LeadsNS.ClearAll) => {
			state.all = new ResponseCatalog<RbidosLeadModel>()
			state.requestParams = new RequestParams()
		},

		setLeadsIds: (state, action: LeadsNS.SetLeadsIds) => {
			state.selectedLeadIds = [...new Set<number>(action.payload)]
		},
		clearLeadsIds: (state, action: LeadsNS.ClearLeadsIds) => {
			state.selectedLeadIds = []
		},
		massUpdateLeadsIds: (state, action: LeadsNS.MassUpdateLeadsIds) => {},
		socketMassUpdateLeadsIds: (state, action: LeadsNS.SocketMassUpdateLeadsIds) => {},
		massUpdateLeadsFile: (state, action: LeadsNS.MassUpdateLeadsFile) => {},
	},
})
